import React from 'react';
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import { padCalendar, numTo2DecimalsPercent, getEntryClass } from "./../../../../util";

export const dandOSelectorColumns = ({ onDandOClick, status }) => {

    let columns = [{
			title: "Company Name",
			name: "companyName",
			onClick: (dando) => dando.enabled && onDandOClick(dando),
			getClassName: (dando) => {
				const entryClass = getEntryClass(dando);
				return dando.enabled ? entryClass+'-clickable' : entryClass;
			},
			colNum: 1,
			sortyBy: 'companyName',
			textAlign: 'left',
		},
		{
			title: "Ticker",
			name: "symbol",
			colNum: 2,
			getClassName: getEntryClass,
			sortyBy: "ticker",
		},
		{
			title: "Risk Assessment Date",
			name: "riskAssessmentDate",
			colNum: 3,
			getClassName: getEntryClass,
			format: (riskAssessmentDate) => padCalendar(riskAssessmentDate),
			sortyBy: "riskAssessmentDate",
			width: 150
		},
		{
			title: "Date Added",
			name: "dateAdded",
			colNum: 4,
			getClassName: getEntryClass,
			format: (dateAdded) => padCalendar(dateAdded),
			sortyBy: "dateAdded",
		},
		{
			title: "Status",
			name: "status",
			colNum: 5,
			getClassName: getEntryClass,
			sortyBy: "status",
		},
		{
			title: "SAR Risk Score\u00AE",
			name: "riskDataScore",
			colNum: 6,
			getClassName: getEntryClass,
			format: (riskDataScore) => numTo2DecimalsPercent(riskDataScore),
			sortyBy: "riskScore",
		},
		{
			title: "Download",
			colNum: 7,
			noSort: true,
			getClassName: (dando) => {
				const entryClass = getEntryClass(dando);
				return status === "COMPLETED"? entryClass+"-clickable" : entryClass;
			},
			format: (dando) => <React.Fragment>
				{dando.status === "COMPLETED" && dando.excelURL &&
				<FaFileExcel className="editBtn" onClick={() => window.location.href=dando.excelURL}/> }

				{dando.status === "COMPLETED" && dando.pdfURL &&
				<FaFilePdf className="editBtn" onClick={() => window.location.href=dando.pdfURL}/> }
			</React.Fragment>,
		}
	]

    return columns;
}


// WEBPACK FOOTER //
// ./src/common/components/TableGrid/tableColumn/DandOSelectorColumns.js